module.exports = __webpack_public_path__ + "app-static/img/joinus.75a28785.jpg";